import { render, staticRenderFns } from "./ReportTaggableList.vue?vue&type=template&id=a579d3de&"
import script from "./ReportTaggableList.vue?vue&type=script&lang=js&"
export * from "./ReportTaggableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports